module.exports = __webpack_public_path__ + "static/media/close.52da487a.svg";